import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => {
    // Create a new div element
   
    if(typeof document !== 'undefined'){
        function isChatDisabledOnWeakened(): boolean {
            if(siteMessage("disableChatOnWeakened").toString().toLowerCase() === "true"){
                const now = new Date();
                const options: Intl.DateTimeFormatOptions = { 
                timeZone: 'America/Chicago', 
                hour: '2-digit' as '2-digit', 
                minute: '2-digit' as '2-digit', 
                hour12: false 
                };

                const usDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
                const dayOfWeek = usDate.getDay(); // getDay() returns 0 for Sunday, 1 for Monday, ..., 6 for Saturday

                // Check if the day is Saturday (6) or Sunday (0)
                const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
                return !isWeekend;
            } else {
                return true;
            }
        }
        function isWithinUsBusinessHours(): boolean {
            const now = new Date();

            // Correct options using the specific allowed values
            const options: Intl.DateTimeFormatOptions = { 
              timeZone: 'America/Chicago', 
              hour: '2-digit' as '2-digit', 
              minute: '2-digit' as '2-digit', 
              hour12: false 
            };
          
            const usTime = now.toLocaleString('en-US', options);
          
            // Extract hour and minute as integers
            const [usHour, usMinute] = usTime.split(':').map(Number);
            const openingTime = siteMessage("openingTime").toString().toLowerCase();
            const closingTime = siteMessage("closingTime").toString().toLowerCase();
            const [openingUsHour, openingUsMinute] = openingTime.split(':').map(Number);
            const [closingTimeUsHour, closingTimeUsMinute] = closingTime.split(':').map(Number);
          
            // Check if time is between 7:30 AM and 4:30 PM
            const isAfterOpening = usHour > openingUsHour || (usHour === openingUsHour && usMinute >= openingUsMinute); // After 7:30 AM
            const isBeforeClosing = usHour < closingTimeUsHour || (usHour === closingTimeUsHour && usMinute <= closingTimeUsMinute); // Before 4:30 PM
            return isAfterOpening && isBeforeClosing && isChatDisabledOnWeakened();
          }
        
        var newDiv = document.createElement("a");

        // Set the content of the div
        newDiv.innerHTML = isWithinUsBusinessHours() ? String(siteMessage("liveChatMessage")) : String(siteMessage("liveChatClosingMessage"));

        // Apply styles to the div
        newDiv.style.height = "28px";
        newDiv.style.position = "fixed";
        if(siteMessage("is_production").toString().toLowerCase() !== "true"){
            newDiv.style.backgroundColor = "#a22e31";
        } else {
            newDiv.style.backgroundColor = "#a22e31";
        }
        newDiv.style.bottom = "1px";
        newDiv.style.zIndex = "1";
        newDiv.style.right = "29px";
        newDiv.style.borderRadius = "28px";
        newDiv.style.color = "white";
        newDiv.style.fontWeight = "600";
        newDiv.style.fontFamily = "'Roboto-Bold', sans-serif"; 
        newDiv.style.fontSize = "12px";
        newDiv.style.display = isWithinUsBusinessHours() ? "none":"flex";
        newDiv.style.justifyContent = "center";
        newDiv.style.alignItems = "center";
        newDiv.style.padding = "0px 15px";
        newDiv.style.cursor = "default";
        newDiv.setAttribute("class", "newMessageElement");
        let emailText = newDiv.innerHTML;
        let emailMatch = emailText.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/); // Regex for emails
        if (emailMatch) {
            newDiv.style.cursor = "pointer";
            // Add event listener for click
            newDiv.setAttribute("href", `mailto:${emailMatch?.[0] || ""}`);
            newDiv.style.cursor = "pointer";
            // newDiv.addEventListener("click", function () {
            //     // Extract the email from the text using a regular expression
            //     // Create a temporary input element to copy the email to clipboard
            //     var tempInput = document.createElement("input");
            //     tempInput.value = emailMatch?.[0] || ""; // Set the value to the email
            //     document.body.appendChild(tempInput); // Append it to the body
            //     tempInput.select(); // Select the input's content
            //     document.execCommand("copy"); // Copy to clipboard
            //     document.body.removeChild(tempInput); // Remove the temporary input

            //     // Create and show a "copied" message
            //     var copiedMessage = document.createElement("div");
            //     copiedMessage.innerHTML = "Email copied to clipboard!";
            //     copiedMessage.style.position = "fixed";
            //     copiedMessage.style.bottom = "30px";
            //     copiedMessage.style.right = "30px";
            //     copiedMessage.style.padding = "4px 15px";
            //     copiedMessage.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
            //     copiedMessage.style.color = "white";
            //     copiedMessage.style.borderRadius = "15px";
            //     copiedMessage.style.fontSize = "14px";
            //     copiedMessage.style.zIndex = "1000";

            //     document.body.appendChild(copiedMessage);

            //     setTimeout(function () {
            //         document.body.removeChild(copiedMessage);
            //     }, 2500);
                
            // });

        }

        // Append the new div to the body
        //document.body.appendChild(newDiv);

        React.useEffect(() => {
            const style = document.createElement('style');
            style.innerHTML = `
                iframe#genesys-mxg-frame{
                bottom: 19px !important;
                }
                .acquire-launcher-wrapper {
                    top: auto !important;
                    bottom: 31px !important;
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 5px -2px, rgba(0, 0, 0, 0.14) 0px 1px 4px 2px, rgba(0, 0, 0, 0.12) 0px 1px 4px 1px !important;
                    margin-right: 7px !important;
                }
                .tagove-livechat-widget{
                    background: blue;
                    
                }
                @media (max-width: 500px) { 
                    .newMessageElement{
                        font-size: 11px !important;
                        right: 5px !important;
                    }
                }
            `;
            document.head.appendChild(style);

            function checkAndClearElements() {
                const elements = document.querySelectorAll(".tagove-livechat-widget"); 
                const elements2 = document.querySelectorAll(".genesys-app");  
                
                if (elements.length > 0 || elements2.length > 0) {
                  
                  // Loop through each element and set innerHTML to an empty string
                 if(!isWithinUsBusinessHours()){
                    if(elements.length > 0) {
                        elements.forEach(element => {
                            element.setAttribute("style","display:none"); // Clears the content
                        });
                    } 
                    if(elements2.length > 0) {
                        elements2.forEach(element => {
                            element.setAttribute("style","display:none"); // Clears the content
                        });
                    }
                 } else {
                    if(elements.length > 0) {
                        elements.forEach(element => {
                            element.setAttribute("style","display:block"); // Clears the content
                        });
                    } 
                    if(elements2.length > 0) {
                        elements2.forEach(element => {
                            element.setAttribute("style","display:block"); // Clears the content
                        });
                    }
                 }
                  
                  // Stop the interval once the elements are found and cleared
                  clearInterval(intervalId);
                }
              }
              
              // Set an interval to run the function every 500 milliseconds
              const intervalId = setInterval(checkAndClearElements, 500);
            

               // Function to handle URL changes
        const handleUrlChange = () => {
            checkAndClearElements(); // Call your custom function here
        };
        // Function to handle pushState and replaceState
        const handleHistoryChange = () => {
            handleUrlChange();
        };

         // Attach the popstate event listener
         window.addEventListener('popstate', handleUrlChange);
         // Override pushState and replaceState to capture those events
         const originalPushState = window.history.pushState;
         const originalReplaceState = window.history.replaceState;
 
         window.history.pushState = function (...args) {
             originalPushState.apply(this, args);
             handleHistoryChange();
         };
 
         window.history.replaceState = function (...args) {
             originalReplaceState.apply(this, args);
             handleHistoryChange();
         };

        // Call the function for the initial load
        handleUrlChange();

            // Cleanup on component unmount
            return () => {
                document.head.removeChild(style);
                window.removeEventListener('popstate', handleUrlChange);
                window.history.pushState = originalPushState; // Restore original method
                window.history.replaceState = originalReplaceState; // Restore original method
            };
        }, []);
    }

    React.useEffect(() => {
        const updateCanonicalTag = () => {
          let canonicalUrl = `${window.location.origin}${window.location.pathname}`;
          const canonicalLink = document.querySelector("link[rel='canonical']");

          const queryParams = new URLSearchParams(window.location.search);
          
            if (queryParams.get('page') === '1') {
            } else {
                canonicalUrl =  window.location.href;
            }
    
          if (canonicalLink) {
            canonicalLink.setAttribute('href', canonicalUrl);
          } else {
            const link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', canonicalUrl);
            document.head.appendChild(link);
          }
        };
    
        // Override pushState
        const originalPushState = window.history.pushState;
        window.history.pushState = function (...args) {
          const result = originalPushState.apply(this, args);
          const event = new Event('pushState');
          window.dispatchEvent(event);
          return result;
        };
    
        // Override replaceState
        const originalReplaceState = window.history.replaceState;
        window.history.replaceState = function (...args) {
          const result = originalReplaceState.apply(this, args);
          const event = new Event('replaceState');
          window.dispatchEvent(event);
          return result;
        };
    
        // Listen for URL changes
        const handleUrlChange = () => {
          updateCanonicalTag();
        };
    
        window.addEventListener('popstate', handleUrlChange); // Back/forward navigation
        window.addEventListener('pushState', handleUrlChange); // Programmatic navigation
        window.addEventListener('replaceState', handleUrlChange); // Programmatic replacement
    
        // Update the canonical tag initially
        updateCanonicalTag();
    
        return () => {
          // Cleanup listeners
          window.removeEventListener('popstate', handleUrlChange);
          window.removeEventListener('pushState', handleUrlChange);
          window.removeEventListener('replaceState', handleUrlChange);
    
          // Restore original methods (optional)
          window.history.pushState = originalPushState;
          window.history.replaceState = originalReplaceState;
        };
      }, []); // Run only once on mount

    return <Page as="footer" isFooter={true} {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
        <CookiePrivacyPolicyPopup />
    </Page>
};

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
